import { lazy, Suspense } from 'react';
import LoadingCom from '../../../components/LoadingCom';
import PageErrorBoundary from '../../../components/PageErrorBoundary';

const PricingPage = lazy(() => import('./Index'));

export default function SuspendedPricingPage(props: any) {
  return (
    <PageErrorBoundary>
      <Suspense fallback={<LoadingCom />}>
        <PricingPage {...props} />
      </Suspense>
    </PageErrorBoundary>
  );
}
